const cacheLocation = (location, cacheDuration) => {
  const locationStorage = {
    location,
    expireAt: Date.now() + cacheDuration * 24 * 60 * 60 * 1000
  };
  window.localStorage.setItem('location', JSON.stringify(locationStorage));
};

export default cacheLocation;